import { Box, Typography, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTitleContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  margin: theme.spacing(2, 0),
  position: "relative",
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  flex: 1,
  height: "3px",
  backgroundColor: theme.palette.secondary.main,
  borderRadius: "2px",
  "&::before, &::after": {
    borderColor: theme.palette.secondary.main,
    borderWidth: "2px",
  },
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  color: theme.palette.primary.main,
  fontWeight: 700,
  fontSize: "2rem",
  textAlign: "center",
  background: `linear-gradient(135deg, ${theme.palette.primary.main}, rgba(90, 100, 119, 0.8))`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.2rem",
    padding: theme.spacing(0, 1),
  },
}));

export const TitleComponent = ({ title }: { title: string }) => {
  return (
    <StyledTitleContainer>
      <StyledDivider />
      <StyledTitle variant="h4">{title}</StyledTitle>
      <StyledDivider />
    </StyledTitleContainer>
  );
};
